document.addEventListener('DOMContentLoaded', () => {
  const tabsBlocks = document.querySelectorAll('.wp-block-o-vertical-tabs');

  tabsBlocks.forEach(tabsBlock => {
    const tabButtons  = tabsBlock.querySelectorAll('.tabs-list-item');
    const tabContents = tabsBlock.querySelectorAll('.tabs-list__item__content');
    const tabImages   = tabsBlock.querySelectorAll('.tabs-item');
    const tabsItems   = tabsBlock.querySelector('.tabs-items');
    const tabContainers = tabsBlock.querySelectorAll('.tabs-list__item-container');

    const isInteractiveTarget = target => {
      return Boolean(target.closest('a, button, input, select, textarea, [role="button"], [role="link"]'));
    };

    if (tabsItems) {
      const firstImg = tabsItems.querySelector('.tabs-item.is-active img');
      if (firstImg) {
        const markLoaded = () => tabsItems.classList.add('images-loaded');
        if (firstImg.complete && firstImg.naturalWidth > 0) {
          markLoaded();
        } else {
          firstImg.addEventListener('load',  markLoaded, { once: true });
          firstImg.addEventListener('error', markLoaded, { once: true });
        }
      }
    }

    tabButtons.forEach(btn => {
      const panel = btn.closest('.tabs-list__item-container')?.querySelector('.tabs-list__item__content');
      if (panel) {
        panel.id = `vtab-${btn.dataset.tab}`;
        btn.setAttribute('aria-controls', `vtab-${btn.dataset.tab}`);
      }
      btn.setAttribute('aria-expanded', btn.classList.contains('is-active') ? 'true' : 'false');
    });

    // ───────────────────────────────────────────────────────────────────────

    tabButtons.forEach(button => {
      button.addEventListener('click', () => {
        const tabId = button.getAttribute('data-tab');

        const currentActiveImage = tabsBlock.querySelector('.tabs-item.is-active');
        
        if (currentActiveImage) {
          currentActiveImage.classList.add('is-sliding-out');
          currentActiveImage.classList.remove('is-active');
        }

        tabButtons.forEach(btn => {
          btn.classList.remove('is-active');
          btn.setAttribute('aria-expanded', 'false');
        });
        tabContents.forEach(content => content.classList.remove('is-active'));
        
        tabImages.forEach(img => {
          if (img !== currentActiveImage) {
            img.classList.remove('is-active');
          }
        });

        button.classList.add('is-active');
        button.setAttribute('aria-expanded', 'true');

        const itemContainer = button.closest('.tabs-list__item-container');
        if (itemContainer) {
          const content = itemContainer.querySelector('.tabs-list__item__content');
          if (content) {
            content.classList.add('is-active');
          }
        }

        const desktopImage = tabsBlock.querySelector(`.tabs-item[data-tab="${tabId}"]`);
        if (desktopImage) {
          desktopImage.classList.add('is-active');
          
          if (currentActiveImage && currentActiveImage !== desktopImage) {
            setTimeout(() => {
              currentActiveImage.classList.remove('is-active', 'is-sliding-out');
            }, 800);
          }
        }
      });
    });

    tabContainers.forEach(container => {
      container.addEventListener('click', event => {
        if (isInteractiveTarget(event.target)) {
          return;
        }

        const triggerButton = container.querySelector('.tabs-list-item');
        if (!triggerButton || triggerButton.classList.contains('is-active')) {
          return;
        }

        triggerButton.click();
      });
    });
  });
});